const backendErrorsLocale = {
  backendErrors: {
    error: {
      unexpected: "Une erreur inattendue s'est produite. Veuillez réessayer plus tard",
      siteHasNoPdl: "Le site n'a pas de PDL",
    },
    signature: {
      requiresEscIntervention: "Le site n'a aucune intervention éligible pour la vente",
      requiresInstallationAppointment:
        "Aucun rendez-vous d'installation / montée en gamme prévu pour ce site n'a pu être trouvé",
    },
  },
};

export type BackendErrorsLocale = typeof backendErrorsLocale;

export default backendErrorsLocale;
